import { FC } from 'react'
import { LayoutHeader } from '@/components/domains/layouts'
import PolicyBeforePrivacy from '@/components/domains/policy/PolicyLocationBeforeService20220125'

const PagePolicyBeforeLocationPrivacy20220125: FC = () => {
  return (
    <>
      <LayoutHeader />
      <PolicyBeforePrivacy />
    </>
  )
}

export default PagePolicyBeforeLocationPrivacy20220125
